import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('firstNameField');

    return {
        FIRST_NAME_FIELD_LABEL: t('firstNameFieldLabel')
    };
};

export default useTranslation;
